const arrowLeft = '<span class="text-xl text-black -translate-y-0.5 inline-block">&lsaquo;</span>';
const arrowRight = '<span class="text-xl text-black -translate-y-0.5 inline-block">&rsaquo;</span>';

const initResponsiveTables = () => {
	const tables = document.querySelectorAll('.text table');

	tables.forEach((table) => {
		// ----------------------------------------
		// 1. Remove existing responsive wrapper
		// ----------------------------------------
		const existingContainer = table.closest('.responsive-table-container');
		if (existingContainer) {
			const parent = existingContainer.parentNode;
			if (parent) {
				parent.insertBefore(table, existingContainer);
			}
			existingContainer.remove();
		}

		// Ensure table still has a parent (failsafe)
		if (!table.parentNode) return;

		// ----------------------------------------
		// 2. Build fresh wrapper structure
		// ----------------------------------------
		const container = document.createElement('div');
		container.classList.add('w-full', 'my-8', 'relative', 'responsive-table-container');

		const wrapper = document.createElement('div');
		wrapper.classList.add('overflow-auto', 'max-w-full', 'w-full');

		// Insert wrapper before table and move table inside it
		table.parentNode.insertBefore(container, table);
		container.appendChild(wrapper);
		wrapper.appendChild(table);

		// ----------------------------------------
		// 3. Only add scroll UI if needed
		// ----------------------------------------
		requestAnimationFrame(() => {
			const overflowing = wrapper.scrollWidth > wrapper.offsetWidth;
			if (!overflowing) return;

			// Create scrollbar UI
			const scrollBar = document.createElement('div');
			const scrollProgress = document.createElement('div');
			const btnRight = document.createElement('button');
			const btnLeft = document.createElement('button');

			scrollBar.classList.add('w-full', 'h-1', 'mb-8', 'bg-gray-light', 'shadow', 'sticky', 'top-0');

			scrollProgress.classList.add('absolute', 'top-0', 'left-0', 'h-full', 'bg-black', 'z-0');

			// Left button
			btnLeft.classList.add(
				'bg-gray-light',
				'rounded-full',
				'shadow',
				'p-2',
				'z-10',
				'absolute',
				'top-1/2',
				'-translate-y-1/2',
				'left-0',
				'touch-manipulation',
				'size-12'
			);
			btnLeft.innerHTML = arrowLeft;

			// Right button
			btnRight.classList.add(
				'bg-gray-light',
				'rounded-full',
				'shadow',
				'p-2',
				'z-10',
				'absolute',
				'top-1/2',
				'-translate-y-1/2',
				'right-0',
				'touch-manipulation',
				'size-12'
			);
			btnRight.innerHTML = arrowRight;

			scrollBar.appendChild(btnLeft);
			scrollBar.appendChild(scrollProgress);
			scrollBar.appendChild(btnRight);

			container.prepend(scrollBar);

			// ----------------------------------------
			// 4. Scroll progress updating
			// ----------------------------------------
			const updateProgress = () => {
				const maxScroll = wrapper.scrollWidth - wrapper.offsetWidth;
				const pct = (wrapper.scrollLeft / maxScroll) * 100;
				scrollProgress.style.width = pct + '%';
			};

			updateProgress();

			wrapper.addEventListener('scroll', updateProgress);

			// ----------------------------------------
			// 5. Scroll buttons
			// ----------------------------------------
			const scrollAmount = () => ((wrapper.scrollWidth - wrapper.offsetWidth) / 100) * 20;

			btnLeft.addEventListener('click', () => {
				wrapper.scrollLeft -= scrollAmount();
			});

			btnRight.addEventListener('click', () => {
				wrapper.scrollLeft += scrollAmount();
			});
		});
	});
};

initResponsiveTables();
window.addEventListener('resize', initResponsiveTables);
